export default __webpack_public_path__ + "static/media/donation.ddfa1daf.svg";